import ChevronRight from '@mui/icons-material/ChevronRight';
import SettingsIcon from '@mui/icons-material/Settings';
import { Box, MenuItem, MenuList, Popover } from '@mui/material';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { POPOVER_TOP_RIGHT } from '@work4all/components/lib/components/menu/components/MenuPopover';
import { HoveredItem } from '@work4all/components/lib/components/menu/components/types';
import { Divider } from '@work4all/components/lib/dataDisplay/divider/Divider';

import { PinnedItem } from './PinnedItem';

export const ShopMenu = ({ id, icon, name, sections, openTable }) => {
  const ref = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();

  const getParentElement = (div: HTMLDivElement) => {
    if (div) {
      return div.parentElement;
    }
    return null;
  };
  const [hoveredItem, setHoveredItem] = useState<HoveredItem>();

  return (
    <Box
      ref={ref}
      display="flex"
      gap="0.75rem"
      alignItems="center"
      flex="1"
      justifyContent="space-between"
      onMouseEnter={(e) => {
        setHoveredItem({ id, anchorEl: e.currentTarget });
      }}
      onMouseLeave={() => {
        setHoveredItem(null);
      }}
    >
      <Box display="flex" gap="0.75rem" alignItems="center">
        {icon}
        {name}
      </Box>

      <ChevronRight color="secondary" />
      {hoveredItem?.anchorEl && (
        <Popover
          open
          anchorEl={getParentElement(hoveredItem.anchorEl)}
          onClose={() => {
            setHoveredItem(null);
          }}
          onMouseLeave={() => {
            setHoveredItem(null);
          }}
          {...POPOVER_TOP_RIGHT}
        >
          <MenuList
            id="split-button-menu"
            autoFocusItem
            onMouseLeave={() => {
              setHoveredItem(null);
            }}
          >
            {sections.map((section) => {
              return (
                <MenuItem key={section.actionKey} onClick={section.onClick}>
                  <PinnedItem
                    renderPin
                    title={section.title}
                    id={section.actionKey}
                    icon={<section.IconComponent />}
                  />
                </MenuItem>
              );
            })}
            <Divider />
            <MenuItem onClick={openTable}>
              <Box display="flex" gap="0.75rem" alignItems="center">
                <SettingsIcon color="secondary" />
                {t('COMMON.SHOP_CONFIGURATION')}
              </Box>
            </MenuItem>
          </MenuList>
        </Popover>
      )}
    </Box>
  );
};
